module.exports = __webpack_public_path__ + "img/1747038613_fg2C.b8eb5130.jpg";